import * as React from 'react';
import { useRef, useState } from 'react';
import { AccessColumnEvent } from '../../../widgets/table/TableWidget';
import { Routes, useJourneyNavigation } from '../../../routes';
import { ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { useAllowed } from '../../../hooks/useAllowed';
import { AppRow } from './AppsPage';
import { styled } from '../../../theme';
import { AppModelAction } from '@journeyapps-platform/cardinal-catalog';
import { SmartDropdownWidget } from '../../../widgets-smart/SmartDropdownWidget';
import { DropdownItem } from '../../../widgets/menus/DropdownWidget';

export interface AppRowWidgetProps {
  event: AccessColumnEvent<AppRow>;
  params: { org_id: string; app_id: string };
}

export const AppDropdown: React.FC<{
  position: { x: number; y: number };
  event: AccessColumnEvent<AppRow>;
  params: { org_id: string; app_id: string };
  close: () => any;
}> = ({ position, close, params, event }) => {
  const { navigate } = useJourneyNavigation(Routes.MANAGE_APPS);
  const isAllowedToMigrateApp = useAllowed({ action: AppModelAction.CREATE, resource: event.row.app });
  const isAllowedToUpdateApp = useAllowed({ action: AppModelAction.UPDATE, resource: event.row.app });
  const isAllowedToDeleteApp = useAllowed({ action: AppModelAction.DELETE, resource: event.row.app });

  let items: DropdownItem[] = [];
  if (!event.row.legacy) {
    items.push({
      label: 'Version control',
      icon: 'edit',
      enabled: isAllowedToUpdateApp,
      action: async () => {
        navigate(Routes.APP_SOURCE_MODE, { ...params, app_id: event.row.key });
      }
    });
    items.push({
      label: 'Git provider',
      icon: 'edit',
      enabled: isAllowedToUpdateApp,
      action: async () => {
        navigate(Routes.APP_SOURCE_PROVIDER, { ...params, app_id: event.row.key });
      }
    });
  } else {
    items.push({
      label: 'Migrate app',
      icon: 'external-link-alt',
      enabled: isAllowedToMigrateApp,
      action: async () => {
        navigate(Routes.MIGRATE_APP, params);
      }
    });
  }

  items.push({
    label: 'Delete project',
    icon: 'trash',
    enabled: isAllowedToDeleteApp,
    action: async () => {
      navigate(Routes.DELETE_APP, { ...params, app_id: event.row.key });
    }
  });

  const { x, y } = position;
  return <SmartDropdownWidget pos={{ x: x, y: y }} onClickOutside={close} items={items} />;
};

export const AppRowWidget: React.FC<AppRowWidgetProps> = (props) => {
  const { event } = props;
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  return (
    <>
      <S.Button
        active={show || !!event.active}
        type={ButtonType.SECONDARY}
        icon="gear"
        forwardRef={ref}
        action={() => {
          const bounds = ref.current!.getBoundingClientRect();
          setPosition({
            x: bounds.x - 170,
            y: bounds.y
          });
          setShow(true);
        }}
      />
      {show ? (
        <AppDropdown event={event} params={props.params} close={() => setShow(false)} position={position} />
      ) : null}
    </>
  );
};
namespace S {
  export const Button = styled(ButtonWidget)<{ active: boolean }>`
    opacity: ${(p) => (p.active ? 1 : 0.1)};
    transition: opacity 0.2s;
  `;
}
